import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

import NotificationContext from '../../context/Notification/notificationContext';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const Notification = () => {
  const classes = useStyles();

  const notificationContext = useContext(NotificationContext);

  const { notification } = notificationContext;

  return (
    notification !== null && (
      <div className={classes.root}>
        <Alert severity={`${notification.type}`}>{notification.msg}</Alert>
      </div>
    )
  );
};

export default Notification;
